import React from "react";
export const DateTimeDisplay = ({ value, type }) => {
  return (
    <span>
      {value<10?`0${value}`:value}
      {/* <span> {type}</span> */}
    </span>
  );
};
